interface TextCardProps {
  name?: string;
  description?: string;
}

const TextCard = ({ name, description }: TextCardProps) => {
  return (
    <div className="flex flex-col items-start justify-center gap-3 sm:gap-4 bg-orange-50 border rounded-lg p-4 sm:p-6 h-auto max-h-[350px] sm:max-h-[400px] md:max-h-[450px] w-full font-serif-kr">
      <div className="relative w-full overflow-y-auto scrollbar-hover-stable">
        <p className="text-gray-700 text-sm md:text-base leading-[1.4] sm:leading-[1.5] md:leading-[1.6] max-h-[200px] sm:max-h-[240px] md:max-h-[265px]">
          {description}
        </p>
      </div>
      <p className="text-gray-700 text-sm md:text-base leading-[1.4] sm:leading-[1.5] md:leading-[1.6] font-medium pt-3 sm:pt-4 md:pt-5">
        - {name}
      </p>
    </div>
  );
};

export default TextCard;
